import { inject, Injectable } from '@angular/core';
import { NzConfigService } from 'ng-zorro-antd/core/config';

@Injectable({
  providedIn: 'root',
})
export class NzGlobalConfigService {
  private readonly nzConfigService = inject(NzConfigService);

  /**
   * Sets the notification position based on the visibility of a banner.
   * this is to avoid overlap between notification and banner
   *
   * @param {boolean} visible - A boolean indicating whether the banner is visible.
   * @returns {void} No value is returned.
   */
  public notificationPositionWhenBannerVisible(visible: boolean): void {
    // eslint-disable-next-line sonarjs/no-selector-parameter
    if (visible) {
      this.nzConfigService.set('notification', { nzTop: '4.75rem' });
    } else {
      this.nzConfigService.set('notification', { nzTop: '1.5rem' });
    }
  }
}
